export enum UserPermissions {
    LogIn = "log_in",
    CreateBuilding = "create_building",
    ReadUser = "read_user",
    UpdateBuilding = "update_building",
    UseInternalTools = "use_internal_tools",
    ReadBuilding = "read_building",
    CreateCustomerAccount = "create_customer_account",
    UpdateCustomerAccount = "edit_customer_account",
    DeleteBuilding = "delete_building",
    RemoveUser = "remove_user",
    AddUser = "add_user",
    GrantAudetteAdmin = "grant_audette_admin",
    GrantUser = "grant_user",
    ReadBenchmarkTags = "read_benchmark_tags",
    UseChatbotBuilding = "use_chatbot_building",
    UseChatbotPortfolio = "use_chatbot_portfolio",
    InAppHelp = "in_app_help",
    AdvancedBuildingAttributes = "advanced_building_attributes",
    ConfigureModelingSettings = "configure_modeling_settings",
    ViewPlanSettings = "view_plan_settings",
    DocumentUploadRead = "document_upload.read",
    DocumentUploadCreate = "document_upload.create",
    DocumentUploadDelete = "document_upload.delete",
}

export enum RoleActions {
    MakeAudetteAdmin = "Make Audette Admin",
    RemoveAudetteAdmin = "Remove Audette Admin",
    MakeMember = "Make Member",
    MakeAdmin = "Make Admin",
    Remove = "Remove",
    Reinvite = "Reinvite",
}

export enum Roles {
    AudetteAdmin = "Audette Admin",
    Admin = "Admin",
    Member = "Member",
}

export enum Tab {
    Settings = "settings",
    Summary = "summary",
    Baseline = "baseline",
    CustomPlan = "customPlan",
    Outcomes = "outcomes",
    Measures = "measures",
    AudettePlan = "audettePlan",
    OutcomesV1 = "outcomesV1",
    VirtualAudit = "virtual-audit",
}

export enum Page {
    Reports = "reports",
    Buildings = "buildings",
    Measures = "measures",
    Portfolio = "portfolio",
}

export enum ChartType {
    ANNUAL_CARBON_EMISSIONS = "ANNUAL_CARBON_EMISSIONS",
    EMISSION_SAVINGS_BY_MEASURES = "EMISSION_SAVINGS_BY_MEASURES",
    ENERGY_AND_EMISSION_INTENSITY = "ENERGY_AND_EMISSION_INTENSITY",
    ANNUAL_CASH_FLOW = "ANNUAL_CASH_FLOW",
    AVG_MARGINAL_ABATEMENT_COST_BY_MEASURE = "AVG_MARGINAL_ABATEMENT_COST_BY_MEASURE",
    CURRENT_ANNUAL_END_USE = "CURRENT_ANNUAL_END_USE",
    EMISSION_INTENSITY_MAP = "EMISSION_INTENSITY_MAP",
}

export enum BuildingSidebarTab {
    energy = "energy",
    construction = "construction",
    equipment = "equipment",
}

export enum BuildingPlansOutcomes {
    audettePlan = "audette plan", //  database is returning both "audette Plan" and "Audette Plan". Using lowercase to use .toLowerCase() when looking for a match in PlanComparator
    baselinePlan = "Baseline Plan",
}
